<footer
    class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
>
    <p>
        <span class="text-black fw-medium">Lockers</span> in collaboration with <a
        href="https://hibootstrap.com/" target="_blank">Biters</a>
    </p>
</footer>
